'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLexisNexisArticle = exports.getOriginalArticleURL = exports.getArticleURL = undefined;

var _date = require('../date');
/*
 * Returns the URL of a news article. If the article is older than 12
 * months, the original will be used. Otherwise, the moreover url will be used.
 * @params {Object} args
 * @params {String} args.dbID    The article's id
 * @params {Number} args.userID  The user's id, if a user exists
 */


var getArticleURL = function getArticleURL(_ref) {
  var dbID = _ref.dbID,
      userID = _ref.userID; // If there's a userID, then we're logged into QuidWeb

  if (userID !== null && isLexisNexisArticle(dbID)) {
    return getLexisNexisArticleURL(userID, dbID);
  }

  return window.location.origin + '/proxy/newscontent/' + dbID;
};

var getOriginalArticleURL = function getOriginalArticleURL(_ref2) {
  var date = _ref2.date,
      originalURL = _ref2.originalURL,
      url = _ref2.url,
      dbID = _ref2.dbID,
      userID = _ref2.userID,
      _ref2$csvExport = _ref2.csvExport,
      csvExport = _ref2$csvExport === undefined ? false : _ref2$csvExport;
  var timestamp = new Date(date).getTime(); // We make an exception for Lexis Nexis articles because they are generally
  // not available online. Instead of showing the originalUrl, get a URL
  // that is served by Quid.

  if (userID !== null && isLexisNexisArticle(dbID)) {
    return getLexisNexisArticleURL(userID, dbID);
  }

  if (csvExport) {
    return originalURL;
  }

  if (originalURL != null && timestamp && (0, _date.hasExpiredByMonths)(timestamp, 12)) {
    return originalURL;
  }

  return url;
}; // Create a Base64 encoded hash of the patternID, articleID, and userID


var getLexisNexisArticleURL = function getLexisNexisArticleURL(userID, dbID) {
  var patternID = 1;
  var hash = window.btoa(patternID + ',' + dbID + ',' + userID);
  hash = hash.replace(/=/g, '');
  return window.location.origin + '/news/article/' + hash + '.html';
};

var isLexisNexisArticle = function isLexisNexisArticle(dbID) {
  return /^mo-ln-/.test(dbID);
};

exports.getArticleURL = getArticleURL;
exports.getOriginalArticleURL = getOriginalArticleURL;
exports.isLexisNexisArticle = isLexisNexisArticle;